import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './Check.module.scss';

export const AppCheckIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      {...rest}
      className={classNames}
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 6.5L7.5 13L19.5 1" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
